import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import BorrowerTerms from "./Terms.Borrower.Component";
import GeneralTerms from "./Terms.Loanstep.General.Component";
import { Component } from "react";
import { compose } from "redux";
import { termsConnector } from "../../../services/terms/connector";

class LoanstepTerms extends Component {
  constructor(props) {
    super(props);
    this.state = { slideIndex: 0 };
  }

  handleChange = (event, newValue) => {
    this.setState({
      slideIndex: newValue,
    });
  };

  render() {
    return (
      <div className="terms-layout body-height">
        <Tabs onChange={this.handleChange} value={this.state.slideIndex}>
          <Tab label="Borrower terms" value={0} />
          <Tab label="General terms" value={1} />
        </Tabs>
        {this.state.slideIndex === 0 && (
          <div className="content-padding">
            <BorrowerTerms {...this.props} />
          </div>
        )}
        {this.state.slideIndex === 1 && (
          <div className="content-padding">
            <GeneralTerms {...this.props} />
          </div>
        )}
      </div>
    );
  }
}
export default compose(termsConnector)(LoanstepTerms);
